import AccountSettingsPage from "../account-settings/AccountSettingsPage";

const ClientSettings = () => (
  <AccountSettingsPage
    showAgreement={false}
    documentTitleKey="clientSettingsTitle"
    documentTitleDefault="Settings | Client"
  />
);

export default ClientSettings;
